"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heatmap = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreHeatmap_1 = require("./CoreHeatmap");
var withChart_1 = require("../_base/withChart");
//
// Internals
//
var heatmapDefinition = {
    chartName: "Heatmap",
    bucketPropsKeys: ["measure", "rows", "columns", "filters", "sortBy"],
    bucketsFactory: function (props) {
        return [
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.MEASURES, props.measure),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.VIEW, props.rows),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.STACK, props.columns),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        var sortBy = getDefaultHeatmapSort(buckets);
        return (_a = backend
            .withTelemetry("Heatmap", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, sortBy).withDimensions(dimensions_1.heatmapDimensions)
            .withExecConfig(execConfig);
    },
};
var WrappedHeatmap = withChart_1.withChart(heatmapDefinition)(CoreHeatmap_1.CoreHeatmap);
/**
 * [Heatmap](https://sdk.gooddata.com/gooddata-ui/docs/heatmap_component.html)
 *
 * Heatmap represents data as a matrix where individual values are represented as colors.
 * Heatmaps can help you discover trends and understand complex datasets.
 *
 * @public
 */
exports.Heatmap = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measure, props.rows, props.columns, props.filters, props.sortBy], props.placeholdersResolutionContext), measure = _a[0], rows = _a[1], columns = _a[2], filters = _a[3], sortBy = _a[4];
    return (react_1.default.createElement(WrappedHeatmap, tslib_1.__assign({}, props, {
        measure: measure,
        rows: rows,
        columns: columns,
        filters: filters,
        sortBy: sortBy,
    })));
};
function getDefaultHeatmapSort(buckets) {
    var viewBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.VIEW);
    var viewAttribute = viewBucket ? sdk_model_1.bucketAttribute(viewBucket) : undefined;
    if (viewAttribute) {
        return [sdk_model_1.newAttributeSort(viewAttribute, "desc")];
    }
    return [];
}
//# sourceMappingURL=Heatmap.js.map